/**
 * Metadatos del sitio alineados con requirements/context.md
 * y navegación multipágina (Stitch: Anime Art Shop).
 */
export const siteConfig = {
  name: "Hikarai",
  shortDescription:
    "Productos de anime hechos en Medellín, con diseños que sí querrías llevar o regalar.",
  locale: "es-CO",
  /** Máximo de impresiones por diseño (marca / requerimiento hikarai.md) */
  maxPrintsPerDesign: 10,
  contact: {
    /** Solo dígitos, sin +, para wa.me */
    whatsappE164: "573332773474",
    instagramHandle: "hikarai.shop",
    instagramUrl: "https://www.instagram.com/hikarai.shop/",
  },
  nav: [
    { id: "inicio", label: "Inicio", href: "/" },
    { id: "historia", label: "Nuestra Historia", href: "/nuestra-historia.html" },
    { id: "colecciones", label: "Colecciones", href: "/colecciones.html" },
    { id: "productos", label: "Stock permanente", href: "/catalogo.html" },
    { id: "comunidad", label: "Comunidad", href: "/comunidad.html" },
  ],
  stitchProjectId: "7044197879162648851",
  stitchProjectTitle: "Anime Art Shop",
} as const;

export type SiteNavItem = (typeof siteConfig.nav)[number];
export type SiteNavId = SiteNavItem["id"];
